// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"176":"projects","192":"pdf","245":"notfound","330":"proof"}[chunkId] + "." + {"176":"0b33948e","192":"bf7d01b6","245":"9b4346f4","330":"36543a0e"}[chunkId] + ".css";
};